const BASE_URL = window.location.origin + "/perf";

export const INFO_URL = `${BASE_URL}/info`;

export const DASHBOARD_DATA_URL = `${BASE_URL}/dashboard`;
export const STATUS_DATA_URL = `${BASE_URL}/status_page`;
export const BOOTSTRAP_DATA_URL = `${BASE_URL}/bootstrap`;
export const GRAPH_DATA_URL = `${BASE_URL}/graphs`;
export const COMPARE_DATA_URL = `${BASE_URL}/get`;
export const COMPARE_COMPILE_DETAIL_GRAPHS_DATA_URL = `${BASE_URL}/compare-compile-detail-graphs`;
export const COMPARE_RUNTIME_DETAIL_GRAPHS_DATA_URL = `${BASE_URL}/compare-runtime-detail-graphs`;
export const COMPARE_COMPILE_DETAIL_SECTIONS_DATA_URL = `${BASE_URL}/compare-compile-detail-sections`;
export const SELF_PROFILE_DATA_URL = `${BASE_URL}/self-profile`;
